






//mobile nav
  





// collection

 $('ul.mob-nav li.m-collections').on('click', function(e) {
    $(".m-c-box").toggle();
     // header[0].classList.toggle('open');
      e.stopPropagation();
    //alert("aaa");
  });

// about

 $('ul.mob-nav li.m-about').on('click', function(e) {
    $(".m-c-box-a").toggle();
     // header[0].classList.toggle('open');
      e.stopPropagation();
    //alert("aaa");
  });

// follow

$('ul.mob-social li.txt-follow').on('click', function(e) {
    $(".m-social").toggle();
     // header[0].classList.toggle('open');
      e.stopPropagation();
    //alert("aaa");
  });

 


//contact

window.slate = window.slate || {};
window.theme = window.theme || {};


slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});






slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();


theme.Article = (function() {

  var selectors = {
    titleJson: '[data-title-json]',
    contentJson: '[data-content-json]',
    excerptJson: '[data-excerpt-json]',
    textJson: '[data-text-json]'
  };
  
  /**
   * Article section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Article(container) {

    this.$container = $(container);
    this.titleObject = JSON.parse($(selectors.titleJson, this.$container).html());
    this.contentObject = JSON.parse($(selectors.contentJson, this.$container).html());
    this.excerptObject = JSON.parse($(selectors.excerptJson, this.$container).html());

    this.format();
  }

  Article.prototype = $.extend({}, Article.prototype, {

    format :function(){

        var wrapper = $('<div><h1 class="type-large">'+this.titleObject+'</h1></div>');
        var grid = $('.grid');
        var content = this.contentObject;

        var images = $('img', this.contentObject);
        var links = $(this.excerptObject);

        // console.log(this.textObject)
        var textBlocks = this.striptag(this.contentObject).split(new RegExp('\r?\n','g')).
          map(function(e){
            return e.length ? '<p>'+e+'</p>' : false;
          })
          .filter(function(e){ return e; });

        var order = ['text', 'text', 'push', 'image', 'push', 'image', 'push', 'text', 'push', 'text_loop', 'links', 'image_loop']
        for(var key in order){
          switch(order[key]){
            case 'text': // append text block
              if(textBlocks.length){
                wrapper.addClass('text').append(textBlocks[0]);
                textBlocks.splice(0,1);
              }
              break;
            case 'image': // append image
              if(images.length){
                images[0].classList.add('loading');
                wrapper.addClass('image').append(images[0]);
                images.splice(0,1);
              }
              break;
            case 'push': // append text block
              grid.append(wrapper);
              wrapper = $('<div></div>');
              break;
            case 'text_loop': // append image
              if(textBlocks.length){
                wrapper.addClass('text');
                while(textBlocks.length){
                  wrapper.append(textBlocks[0]);
                  textBlocks.splice(0,1);
                }
                grid.append(wrapper);
                wrapper = $('<div></div>');
              }
              break;
            case 'links': // append image
              if(links.length){
                wrapper.addClass('links type-small').append(links);
                grid.append(wrapper);
                wrapper = $('<div></div>')
              }
              break;
            case 'image_loop': // append image
              if(images.length){
                while(images.length){
                  images[0].classList.add('loading');
                  wrapper.addClass('image').append(images[0]);
                  images.splice(0,1);
                  grid.append(wrapper);
                  wrapper = $('<div></div>');
                }
              }
              break;
          }
        }

    },

    striptag: function(html){
        html = html.replace(/<br>/g, "$br$");
        // html = html.replace(/(?:\r\n|\r|\n)/g, '$br$');
        var tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        html = tmp.textContent || tmp.innerText;
        html = html.replace(/\$br\$/g, "<br>");
        return html;
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Article;
})();



/**
 * Contact Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace contact
 */

theme.Contact = (function() {

  var selectors = {
    contactJson: '[data-contact-json]'
  };

  /**
   * Article section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Contact(container) {

    this.singleObject = JSON.parse( $(selectors.contactJson, this.$container).html() || '[]');
    this.format();
    this.map();
  }

  Contact.prototype = $.extend({}, Contact.prototype, {

    map :function(){
      var myLatLng = {lat: 28.5038755, lng: 77.1838572};
      var mapOptions = {
          disableDefaultUI: true,
          zoom: 15,
          center: myLatLng,
          styles: [{"elementType":"geometry","stylers":[{"color":"#f5f5f5"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#dadada"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#c9c9c9"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]}]
      };

      // Create the Google Map using our element and options defined above
      var map = new google.maps.Map($('.map')[0], mapOptions);

      var image = {
          url: googlemap_marker,
          size: new google.maps.Size(64, 64),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(32, 32)
      };

      // Let's also add a marker while we're at it
      var marker = new google.maps.Marker({
          title: 'Aman Khana',
          position: myLatLng,
          map: map,
          icon: image
      });
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    format: function() {
      var parentBlock = $('.details');
      var blocks = $(this.singleObject).filter('p');
      var div = $('<div></div>');
      blocks.each(function(i,b ){
        if( i%2 === 0 ){
          div.append($('<span class="type-small-uppercase">'+b.innerHTML+'</span>'));
        } else {
          div.append($('<p class="type-medium">'+b.innerHTML+'</p>'));
          parentBlock.append(div);
          div = $('<div></div>');
        }


      });
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Contact;
})();


$(document).ready(function() {
  var sections = new slate.Sections();
  
  sections.register('contact', theme.Contact);
  sections.register('article', theme.Article);
  
  
  
});






//about us

// var sections = $('.m-page')
//   , nav = $('.c-box-a')
//   , nav_height = nav.outerHeight();

// $(window).on('scroll', function () {
//   var cur_pos = $(this).scrollTop();
//   sections.each(function() {
//     var top = $(this).offset().top - nav_height,
//         bottom = top + $(this).outerHeight();
   
//     if (cur_pos >= top && cur_pos <= bottom) {
//       nav.find('a').removeClass('active');
//       sections.removeClass('active');
      
//       $(this).addClass('active');
//       nav.find('a[href="#'+$(this).attr('id')+'"]').addClass('active');
//     }
//   });
// });

//  var pageURL = $(location).attr("href");
//  var arr=pageURL.split('#')[0];
  

// if( arr == 'https://claymen.in/pages/about'){
   

//   nav.find('a').on('click', function () {
//    // alert(true);
//     var $el = $(this), 
//         id = $el.attr('href');

//     $('html, body').animate({
//       scrollTop: $(id).offset().top - nav_height
//     }, 500);

//     return false;
//   });

// }
// else{
  
//    nav.find('a').on('click', function () {
//      //alert(false);
//     var $el = $(this), 
//         id = $el.attr('href');
        
     
//     $('html, body').animate({
//       scrollTop: $(id).offset().top - nav_height
      
//     }, 500);

//     return false;
//   });
  
// }


$(document).ready(function() {
var thumb_legth = $('.p-slideshow .slick-dots li').length;
  if(thumb_legth == 1){
   $('.p-slideshow .slick-dots').hide();
  }

  
  $(".search-modal__form").on("keypress", function (event) {
           // console.log("aaya");
            var keyPressed = event.keyCode || event.which;
            if (keyPressed === 13) {
               // alert("You pressed the Enter key!!");
                event.preventDefault();
                return false;
            }
        });
});





      
      
      
      $(window).scroll(function(){
        if ($(window).scrollTop() >= 30) {
          $('.sticky').addClass('fixed-header');
        }
        else {
          $('.sticky').removeClass('fixed-header');
        }
      });
      
  // slick slider    
      
      $('.slideshow').slick({
        dots: false,
        infinite: true,
        speed: 300,
        centerMode: true,
        centerPadding:'10px',
        slidesToShow: 6.2,
        slidesToScroll: 1,
        
        
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 3,
              infinite: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3.2,
              slidesToScroll: 1
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      });
      
      
      var $carousel = $('.main-carousel').flickity({
        // options
    
        cellAlign: 'left',
          contain: true,
          wrapAround: true,
          setGallerySize: false,
          "lazyLoad": 2
      });
      $(".main-carousel.product__media-list img").addClass("pageloaded");

      // jQuery
      $carousel.on( 'change.flickity', function( event, index ) {
        console.log( 'Slide changed to ' + index );        
         temp=0;
        var img = event.target;        
        //img_src_to_match = img.src;
        img_src_to_match = "";        
        
        $(".flickity-slider img").each(function(inx){
		  /*        
          if($(this).hasClass( "is-selected" )){
          img_src_to_match = this.src;
          return false;   
          }*/
	
          if(index == inx){
            img_src_to_match = this.src;
            return false;   
          }

        });
        
        if(img_src_to_match !=""){
        getOptVal_opt=""; getOptVal ="";newVariantId = ""; 
          
        $("select[name='id'] option").each(function(){
           var getAttrImageSrc = $(this).attr("variant-image-url");


            if(getAttrImageSrc == img_src_to_match){
              //newVariantId = $(this).attr("value");             

  			console.log(img_src_to_match);
          console.log(getAttrImageSrc);


			  getOptValRoot = $(this).text().split("-");
              getOptVal = getOptValRoot[0].split("/");
              getOptVal_optFirst = getOptVal[0].trim();
              //getOptVal_optSecond = getOptVal[1].trim();
              
              temp =1;
              return false;              
            }
        });        
       
        if(temp == 1){

          if($("variant-selects .product-form__input:first-child").find($('select option')).length > 1){

          $("variant-selects .product-form__input:first-child").find($('select')).val(getOptVal_optFirst).trigger("change");   
          
        //$('select[name="options[Color]"]').val(getOptVal_optFirst).trigger("change");        
        //$('select[name="options[mlveda_country]"]').val(getOptVal_optSecond).trigger("change");       


		var comp = document.querySelector( 'variant-selects' );
        comp.dispatchEvent(new Event("change"));      
          }
        }
        }
      });


	  $carousel.on( 'staticClick.flickity', function( event, pointer, cellElement, cellIndex ) {
     // alert("hello " + cellIndex);   
      $carousel.flickity( 'select', cellIndex + 1 );     
      });	
     
      
      $(document).on("click", "li.m-search", function(){
        $(".header__icon.header__icon--search span.icon-search").trigger( "click" );
        //alert("aaa");
      });
      
      
      //mob header
      
      var header = $('.mobile-nav div.menu-icon');
      var m_icon = $('header.sticky');
      header.on('click', function(e) {
        m_icon[0].classList.toggle("open");
        // header[0].classList.toggle('open');
        e.stopPropagation();
        $('div.h-overlay').hide();
        //alert("aaa");
        if(m_icon[0].classList.contains('open')){
            $('div.h-overlay').show(); 
        }
      });
      $('div.h-overlay').on('click', function(e){
        m_icon.removeClass("open");
        $('div.h-overlay').hide();
      });
      
      //image click change image
      $( ".slick-list.draggable .product__media img" ).on( "click", function() {
        $('slider-component .slick-next').click();

      });
      
      
     